const PUBLIC_ICON_URL = "https://glimmr.app/images/icon.png";
const PUBLIC_INSTALLER_NAME = "glimmr-setup.exe";
const PUBLIC_GOOGLE_ANALYTICS_ID = "glimmr.app";
const PUBLIC_GOOGLE_ANALYTICS_TAG = "G-MRTNWGD34M";
export {
  PUBLIC_ICON_URL as P,
  PUBLIC_INSTALLER_NAME as a,
  PUBLIC_GOOGLE_ANALYTICS_ID as b,
  PUBLIC_GOOGLE_ANALYTICS_TAG as c
};
